import { asObject } from "../coerce";
import { mapApiItemsToCards } from "./contentCardMapper";
import type {
  NotificationSection,
  NotificationsApiResponse,
  PortalContentKind,
} from "../../../@types/portalAluno";

const NOTIFICATION_COLLECTIONS: Array<{
  key: keyof NotificationsApiResponse;
  sourceType: PortalContentKind;
  title: string;
}> = [
  { key: "conteudos", sourceType: "conteudos", title: "Conteúdos" },
  { key: "cursos", sourceType: "cursos", title: "Cursos" },
  {
    key: "segurancaNoTrabalhos",
    sourceType: "seguranca-do-trabalho",
    title: "Segurança do Trabalho",
  },
  {
    key: "t1",
    sourceType: "treinamentos-de-1-ponto",
    title: "Treinamentos de 1 Ponto",
  },
  { key: "comunicados", sourceType: "comunicados", title: "Comunicados" },
  { key: "trilhas", sourceType: "trilhas", title: "Trilhas" },
];

export const mapNotificationsResponse = (
  value: unknown
): NotificationSection[] => {
  const response = asObject<NotificationsApiResponse>(value);
  if (!response) {
    throw new Error("A API retornou uma lista de notificações inválida.");
  }

  return NOTIFICATION_COLLECTIONS.map(({ key, sourceType, title }) => ({
    cards: mapApiItemsToCards(response[key], sourceType),
    key,
    title,
  }));
};
